import { render } from "./P066.vue?vue&type=template&id=756c9feb&scoped=true"
import script from "./P066.vue?vue&type=script&lang=js"
export * from "./P066.vue?vue&type=script&lang=js"

import "./P066.vue?vue&type=style&index=0&id=756c9feb&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756c9feb"]])

export default __exports__